export const CLASS_COMPONENT = 'load-more';

export const CLASS_BTN = `${CLASS_COMPONENT}-btn`;

export const CLASS_LIST_WRAPPER = `${CLASS_COMPONENT}-wrapper`;
